import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAILURE,
  USER_LOGOUT,
  USER_UPDATE
} from './types'
import { authAPI } from '../services/api'

// Login action
export const login = (email, password) => async (dispatch) => {
  dispatch({ type: USER_LOGIN_REQUEST })
  
  try {
    const response = await authAPI.login(email, password)
    console.log('🔐 Login response:', response)
    
    // Store token and user data
    if (response.token) {
      console.log('💾 Storing token in localStorage:', response.token.substring(0, 20) + '...')
      localStorage.setItem('authToken', response.token)
      localStorage.setItem('sessionToken', response.token)
    } else {
      console.error('❌ No token in login response!')
    }
    
    if (response.user) {
      console.log('💾 Storing user in localStorage:', response.user)
      localStorage.setItem('user', JSON.stringify(response.user))
    }
    
    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: {
        user: response.user,
        token: response.token
      }
    })
    
    // Log API version after successful login
    try {
      const apiHealthResponse = await fetch(`${import.meta.env.VITE_API_URL || 'https://tevv-pipeline-api.com'}/health`)
      if (apiHealthResponse.ok) {
        const healthData = await apiHealthResponse.json()
        console.log(`🔗 Connected to API version: ${healthData.version || 'unknown'}`)
        console.log(`🌐 API URL: ${import.meta.env.VITE_API_URL || 'https://tevv-pipeline-api.com'}`)
        console.log(`📊 API Status: ${healthData.status || 'unknown'}`)
      }
    } catch (apiError) {
      console.warn('⚠️ Could not fetch API version:', apiError.message)
    }
    
    return { success: true }
  } catch (error) {
    dispatch({
      type: USER_LOGIN_FAILURE,
      payload: error.response?.data?.detail || error.message || 'Login failed'
    })
    
    return { 
      success: false, 
      error: error.response?.data?.detail || error.message || 'Login failed'
    }
  }
}

// Logout action
export const logout = () => async (dispatch) => {
  try {
    await authAPI.logout()
  } catch (error) {
    console.error('Logout error:', error)
  }
  
  // Clear local storage
  localStorage.removeItem('authToken')
  localStorage.removeItem('sessionToken')
  localStorage.removeItem('user')
  
  dispatch({ type: USER_LOGOUT })
}

// Update user action
export const updateUser = (userData) => ({
  type: USER_UPDATE,
  payload: userData
})

// Verify authentication
export const verifyAuth = () => async (dispatch) => {
  const token = localStorage.getItem('authToken') || localStorage.getItem('sessionToken')
  const userStr = localStorage.getItem('user')
  
  if (!token || !userStr) {
    dispatch({ type: USER_LOGOUT })
    return false
  }
  
  try {
    const user = JSON.parse(userStr)
    
    // First set local user data
    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: { user, token }
    })
    
    // Verify with backend
    const response = await authAPI.verify()
    if (response.user && response.valid) {
      // Update with server-verified user data
      dispatch({
        type: USER_LOGIN_SUCCESS,
        payload: { user: response.user, token }
      })
      
      // Update localStorage with verified user data
      localStorage.setItem('user', JSON.stringify(response.user))
      
      // Check if the user has a valid email (not anonymous)
      if (response.user.email === 'anonymous@research.com' || !response.user.email) {
        // Invalid/anonymous user - logout
        dispatch({ type: USER_LOGOUT })
        return false
      }
      
      return true
    } else {
      // Verification failed
      dispatch({ type: USER_LOGOUT })
      return false
    }
  } catch (error) {
    console.error('Auth verification error:', error)
    dispatch({ type: USER_LOGOUT })
    return false
  }
}